export interface RadioOption<T> {
  name: string;
  value: T;
  disabled?: boolean;
}

interface HorizontalRadioButtonsInputProps<T> {
  options: RadioOption<T>[];
  selectedValue: T;
  onSelectionChange: (value: T) => void;
}

export function HorizontalRadioButtonsInput<T>({
  options,
  selectedValue,
  onSelectionChange,
}: HorizontalRadioButtonsInputProps<T>) {
  return (
    <div className="flex items-center gap-4">
      {options.map((option, index) => {
        const isChecked = selectedValue === option.value;
        const isDisabled = !!option.disabled;

        return (
          <label
            key={index}
            className={`flex items-center gap-2 ${
              isDisabled ? "cursor-not-allowed opacity-50" : "cursor-pointer"
            }`}
          >
            <input
              type="radio"
              disabled={isDisabled}
              checked={isChecked}
              onChange={() => !isDisabled && onSelectionChange(option.value)}
              className="h-4 w-4 accent-[#3551F3]"
            />

            <span className="text-[14px] font-medium text-[#0A0A0A]">
              {option.name}
            </span>
          </label>
        );
      })}
    </div>
  );
};

export default HorizontalRadioButtonsInput;